<template>
    <section class="question">
        <question-tag
            :correctRate="question.avgSolveTime"
            :avgSolveTime="question.avgSolveTime"
            :level="paperLevel"
        ></question-tag>

        <!-- {{solveTime}}
        
        {{setedAnswer}} -->
        <div class="pda-default">

            <div v-if="groupQuestionCount === 1">
                <div class="t-subtitle5">
                    {{ question.contents.text }}
                </div>
                <div class="mgt-16 independent-img-video-bd-radius" v-if="question.contents.image">
                    <img :src="question.contents.image" alt="">
                </div>
                <div class="question-choices">
                    <div class="t-body2 mgt-16">
                        {{isCorrect() ? $t('1270') : $t('1271')}}
                        <!-- Your answer is correct -->
                    </div>
                    <div class="mdc-text-field mdc-text-field--outlined mdc-text-field--with-trailing-icon w-full mgt-4" :id="`answerEl`">
                        <input type="text" class="mdc-text-field__input"
                            maxlength="50" 
                            autocomplete="off"
                            v-model="textAnswer"
                            readonly
                        >
                        <div class="mdc-notched-outline">
                            <div class="mdc-notched-outline__leading"></div>
                            <div class="mdc-notched-outline__notch">
                            
                            </div>
                            <div class="mdc-notched-outline__trailing"></div>
                        </div>
                    </div>
                    <div v-if="!isCorrect()" class="mgt-16">
                        <hr class="divider">
                        <div class="t-body2 mgt-16">
                            {{$t('1272')}}
                            <!-- Check the right answer! -->
                        </div>
                        <div class="t-body2">
                            <div class="t-body1 choice">
                                <div class="mgr-16 mgl-16">
                                    <span>{{textCorrect}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> 
            </div>

            <div class="group mgb-30" v-else>
                <div class="bottom-card1">
                    <div class="mdc-card mdc-elevation--z2 bottom-card1-1 bg-documentGray"></div>
                </div>
                <div class="bottom-card2">
                    <div class="mdc-card mdc-elevation--z1 bottom-card2-1 bg-documentGray"></div>
                </div>
                
                <div class="t-subtitle5">
                    {{groupQuestionTitle}}
                </div>

                <div class="mdc-card mdc-elevation--z3 pda-default mgt-16 bg-documentGray">
                    <div class="t-headline14">
                        {{ question.contents.text }}
                    </div>
                    <div class="mgt-16 independent-img-video-bd-radius" v-if="question.contents.image">
                        <img :src="question.contents.image" alt="">
                    </div>
                    <div class="question-choices">
                        <div class="t-body2 mgt-16">
                            {{isCorrect() ? $t('1270') : $t('1271')}}
                            <!-- Your answer is correct -->
                        </div>
                        <div class="mdc-text-field mdc-text-field--outlined mdc-text-field--with-trailing-icon w-full mgt-4" :id="`answerEl`">
                            <input type="text" class="mdc-text-field__input"
                                maxlength="50" 
                                autocomplete="off"
                                v-model="textAnswer"
                                readonly
                            >
                            <div class="mdc-notched-outline">
                                <div class="mdc-notched-outline__leading"></div>
                                
                                <div class="mdc-notched-outline__trailing"></div>
                            </div>
                        </div>

                        
                        <div v-if="!isCorrect()" class="mgt-16">
                            <hr class="divider">
                            <div class="t-body2 mgt-16">
                                {{$t('1272')}}
                                <!-- Check the right answer! -->
                            </div>
                            <div class="t-body2">
                                <div class="t-body1 choice">                                    
                                    <div class="mgr-16 mgl-16">
                                        <span>{{textCorrect}}</span>
                                    </div>
                                    
                                </div>
                                
                            </div>
                        </div>
                    </div>
                </div>

            </div>
            

            <div class="h-1"></div>
            
            <question-tip v-if="question.tip" :tip="question.tip"/>
        </div>


        <question-feedback
            :commonFeedback="question.feedback.common"
            :correctFeedback="question.feedback.correct"
            :incorrectFeedback="question.feedback.incorrect"
            :videoFeedback="question.feedback.video"
            :feedbackStatus="feedback"
            :correct="question.correct"
            :questionId="question.questionId"
        ></question-feedback>
    </section>
</template>

<script>
/**
 * 단일답안 문항 피드백 컴포넌트(short answer type question feedback component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import {MDCTextField} from '@material/textfield'
import QuestionTag from './QuestionTag.vue'
import QuestionTip from './QuestionTip.vue'
import QuestionFeedback from './QuestionFeedback.vue'
import {questionMixin} from '@/mixins/question.js'

export default {
    props: ['question', 'groupQuestionCount', 'groupQuestionTitle', 'paperLevel', 'feedback'],
    data() {
        return {
            textAnswer: '',
            textCorrect: ''
        }
    },
    components: {
        'question-tag': QuestionTag,
        'question-tip': QuestionTip,
        'question-feedback': QuestionFeedback
    },

    mixins: [questionMixin],

    mounted() {
        this.textAnswer = this.question.textAnswer
        this.textCorrect = this.question.textCorrect
        const textField = new MDCTextField(document.getElementById(`answerEl`))
    },
}
</script>
<style scoped>
.question-choices .choice .correct-icon {
    min-width: 32px;
    height: 32px;}

    
</style>